"use client";

/**
 * Tiny client-only wrapper around the hero `<img>` so its `onError` handler
 * can live in the browser. `PageHeroLayout` itself stays a shared/universal
 * component (renderable in either context), and delegates the image render
 * to this leaf when the admin has supplied a hero image URL.
 *
 * Behaviour on broken URL: hide the element so the layout doesn't ship a
 * busted placeholder. The default decorative illustration is *not* used as a
 * fallback — admins set images deliberately, so a broken URL is a real signal.
 */

import React from "react";

export interface PageHeroImageProps {
  src: string;
  alt: string;
  className?: string;
}

export const PageHeroImage: React.FC<PageHeroImageProps> = ({
  src,
  alt,
  className,
}) => (
  // eslint-disable-next-line @next/next/no-img-element
  <img
    src={src}
    alt={alt}
    className={
      className ??
      "w-full max-w-[580px] aspect-[4/3]  rounded-2xl"
    }
    onError={(e) => {
      (e.currentTarget as HTMLImageElement).style.display = "none";
    }}
  />
);
